import React, { useEffect, useState } from 'react'
import { listFollowersService } from '../../Service/ReligiousPlaceService'
import PaginatorComponent from '../PaginatorComponent'
import { useTranslation } from 'react-i18next'

function ReligiousPlaceFolowersComponent({access_key}) {

    const [users, setUsers] = useState()
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(1)
    const [countFollowers, setCountFollowers] = useState(1)
    const { t } = useTranslation('user_home');

    useEffect(()=>{
        handleListFollowers()
    },[access_key, page])

    const handleListFollowers = () => {
        listFollowersService(access_key, page).then(res=>{
            setUsers(res.rows)
            setTotal(res.pages)
            setCountFollowers(res.countResult)
        })
    }

    return (
        <div className='flex flex-column gap-2'>
            <div className='flex flex-column gap-2'>
                <div><span className='font-bold'>{countFollowers}</span> {t('user_home_followers_count_people')}</div>
                {users && users.length > 0 ? users.map((item, key)=>(
                    <div key={key} className='flex gap-1 border-1 border-round p-2'>
                        <div>{item.name}, </div>
                        <div>{t('user_home_followers_following_since')}</div>
                        <div>{new Date(item.created_on).toLocaleDateString()}</div>
                    </div>
                ))
                :
                <div></div>}
            </div>
            <PaginatorComponent page={page} setPage={setPage} total={total} />
        </div>
    )
}

export default ReligiousPlaceFolowersComponent